import { motion } from 'framer-motion';
import RunawayButton from '../components/RunawayButton';
import '../styles/templates.css';

const DiscoBalls = () => (
  <div className="disco-balls">
    {[...Array(10)].map((_, i) => (
      <motion.div
        key={i}
        className="disco-element"
        style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
        }}
        animate={{
          scale: [0.8, 1.2, 0.8],
          opacity: [0.5, 1, 0.5],
          rotate: [0, 360],
        }}
        transition={{
          duration: 2 + Math.random() * 2,
          repeat: Infinity,
          delay: Math.random() * 2,
        }}
      >
        {['\uD83E\uDEA9', '\uD83D\uDC83', '\uD83D\uDD7A', '\u2728', '\uD83C\uDFB6'][Math.floor(Math.random() * 5)]}
      </motion.div>
    ))}
  </div>
);

const DanceNightTemplate = ({ question, onYes, showCta, cta, patternStyle = {}, preview, name }) => {
  if (showCta) {
    return (
      <motion.div
        className="template dance-template cta-view"
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="pattern-overlay" style={patternStyle} />
        <DiscoBalls />
        <div className="cta-content">
          <motion.div
            className="success-icon"
            animate={{ rotate: [0, 10, -10, 0], scale: [1, 1.1, 1] }}
            transition={{ duration: 0.5, repeat: Infinity }}
          >
            {'\uD83E\uDEA9'}
          </motion.div>
          <h1>Let's Dance!</h1>
          <p className="cta-text">{cta}</p>
          <motion.div
            className="confetti"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {'\uD83D\uDC83\uD83C\uDFB6\uD83E\uDEA9\uD83C\uDFB6\uD83D\uDD7A'}
          </motion.div>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="template dance-template">
      <div className="pattern-overlay" style={patternStyle} />
      <div className="template-content">
        {/* Static preview image centered */}
        {preview && (
          <img
            src={preview}
            alt={name}
            className="preview-image-small"
          />
        )}

        {/* Question centered */}
        <h1 className="invite-question" style={{ textAlign: 'center' }}>
          {question}
        </h1>

        {/* Yes Button */}
        <div className="button-container">
          <button className="yes-button dance-yes" onClick={onYes}>
            Let's Go!
          </button>
        </div>
      </div>

      <RunawayButton className="dance-no">
        Two left feet...
      </RunawayButton>
    </div>
  );
};

export default DanceNightTemplate;
